import React from "react";
import { Link } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import { CreateNoteIcon, EditHomeIcon, EditNoteIcon, MetricsIcon, PreviewNoteIcon } from "./AdminIcons";
import { FISP_TV_ADMIN_MENU } from "./config";

const ICON_BY_ID = {
    create: CreateNoteIcon,
    edit: EditNoteIcon,
    preview: PreviewNoteIcon,
    metrics: MetricsIcon,
    home: EditHomeIcon,
};

export default function FispTvAdminDashboard() {
    return (
        <AdminLayout
            showNavLinks={false}
            showLogout={true}
            centered={true}
            pageClassName="tv-admin-dashboard-page"
        >
            <section className="tv-admin-dashboard-stage">
                <div className="tv-admin-dashboard-grid">
                    {FISP_TV_ADMIN_MENU.map((item) => {
                        const Icon = ICON_BY_ID[item.id];

                        return (
                            <Link key={item.id} to={item.to} className="tv-admin-dashboard-card">
                                <span className="tv-admin-dashboard-icon">
                                    <Icon />
                                </span>
                                <span className="tv-admin-dashboard-link">
                                    {item.label}
                                </span>
                            </Link>
                        );
                    })}
                </div>
            </section>
        </AdminLayout>
    );
}
